// src/hooks/useSocket.js
import { useEffect, useState } from 'react';
import { io } from 'socket.io-client';

const SOCKET_URL = process.env.REACT_APP_BASE_API_URL?.split("/api/v1")[0];

class SocketService {
  socket = null;

  connect() {
    if (!this.socket) {
      this.socket = io(SOCKET_URL, {
        transports: ["websocket"],
      });

      this.socket.on("connect", () => {
        console.log("✅ Connected to socket:", this.socket.id);
      });

      this.socket.on("disconnect", () => {
        console.log("❌ Socket disconnected");
      });
    }
    return this.socket;
  }

  getSocket() {
    return this.socket;
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }
}

const socketService = new SocketService();


const useSocket = ({refId, appendBrandId = true, apiKey}) => {

  const [webhookData, setWebhookData] = useState(null);
  
  useEffect(() => {
    if (!refId) return;

    if (appendBrandId && apiKey) {
      refId = `${refId}-${apiKey}`;
    }
    const socket = socketService.connect();

    socket.on(refId, (msg) => {
      // console.log(`📩 Received ${refId}:`, msg);
      setWebhookData(msg);
    });

    return () => {
      socket.off(refId);
    };
  }, [refId, appendBrandId]);

  return { socket: socketService.getSocket(), webhookData };
};

export default useSocket;
